'use client';

import { GridColDef, getGridNumericOperators } from '@mui/x-data-grid';

import { isOwnerPortal, isTenantPortal } from '../../../utils';

const numericOperators = getGridNumericOperators();

export const getUtilizationDetailsColumns = ({ facilityId, getUrlToSubscriptionPage }): GridColDef[] => [
	{
		field: 'lastName',
		headerName: 'Last Name',
		editable: false,
		groupable: false,
		flex: 1,
	},
	{
		field: 'firstName',
		headerName: 'First Name',
		editable: false,
		groupable: false,
		flex: 1,
	},
	{
		field: 'accountId',
		headerName: 'Account ID',
		editable: false,
		groupable: false,
		flex: 1,
		filterOperators: numericOperators,
		renderCell: ({ row, value: accountId }) => {
			if (isTenantPortal || isOwnerPortal) {
				return `AC-${accountId}`;
			}

			return (
				<a
					style={{ color: 'blue' }}
					target={window.parent.Cypress ? '_self' : '_blank'}
					href={getUrlToSubscriptionPage(row.subscriptionId, facilityId, accountId)}
					data-cy='account-id-link'
					rel='noreferrer'
				>
					AC-{accountId}
				</a>
			);
		},
	},
	{
		field: 'subscriptionName',
		headerName: 'Subscription Name',
		editable: false,
		groupable: false,
		flex: 1.5,
	},
	{
		field: 'rateName',
		headerName: 'Rate',
		editable: false,
		groupable: false,
		flex: 1.5,
	},
	{
		field: 'sublotName',
		headerName: 'Sublot',
		editable: false,
		groupable: false,
		flex: 1.5,
	},
];
